/**
 * Vuelta al inicio del curso.
 *
 * Las pantallas que cuelgan de un curso (progreso, apuntes, ajustes,
 * repaso) necesitan todas la misma salida, y hasta ahora solo la
 * tenia Apuntes: desde Progreso y Ajustes habia que usar el menu
 * lateral o el boton del navegador. Por eso salir del curso no
 * llevaba siempre al mismo sitio.
 *
 * Se extrae a un componente en vez de copiar el enlace tres veces,
 * para que la proxima pantalla que cuelgue de un curso lo herede.
 */

import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useCourse } from '@/contexts/CourseContext'

interface Props {
  /** Se oculta al imprimir, como el resto de la navegacion. */
  className?: string
}

export function MwBackToCourse({ className = '' }: Props) {
  const { href } = useCourse()

  return (
    <div className={`mw-no-print mb-5 ${className}`}>
      <Link
        to={href('')}
        className="inline-flex items-center gap-1.5 no-underline"
        style={{ fontSize: 13, color: 'var(--mw-ink-secondary)' }}
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        Volver al curso
      </Link>
    </div>
  )
}
